// "A draft from today, 10:42": offered at the top of Receive stock and a new purchase order
// when this device kept one (docs/plans/dialog-safety.md, board DraftResume).
import { Button, IconTile } from '@ims/ui'
import { Clock } from '@ims/ui/icons'
import { useSettings } from '../hooks.ts'
import { dateTime } from '../lib/format.ts'

export function DraftBanner({
  savedAt,
  summary,
  onStartNew,
  onContinue,
}: {
  savedAt: string
  /** "5 lines · Rs 31,976.00". */
  summary: string
  onStartNew: () => void
  onContinue: () => void
}) {
  const settings = useSettings()
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-buy-light bg-buy-wash px-3.5 py-3">
      <IconTile area="buy" size="sm">
        <Clock className="size-4" />
      </IconTile>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-ink">A draft from {dateTime(savedAt, settings)}</p>
        <p className="text-xs text-muted">{summary} · kept on this device</p>
      </div>
      <Button variant="secondary" onClick={onStartNew}>
        Start new
      </Button>
      <Button onClick={onContinue}>Continue the draft</Button>
    </div>
  )
}

/** Under the banner once continued: lines whose product is gone, or no longer due. */
export function DroppedNote({ count }: { count: number }) {
  if (count === 0) return null
  return (
    <p className="text-sm text-warning">
      {count === 1
        ? '1 line of the draft was left out: its product is gone or no longer due.'
        : `${count} lines of the draft were left out: their products are gone or no longer due.`}
    </p>
  )
}
